export default __webpack_public_path__ + "static/media/image13.d0698dcc.jpg";